import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import { getProtectedRoute } from 'helpers/routeHelper';

import Breadcrumb from 'molecules/Breadcrumb';

import { connect } from 'react-redux';
import { PageWrapper } from './styles';
import routes from './routes';

class DataValidationRouter extends Component {
  render() {
    const { match: { url, isExact }, viewState: { isMobileView } } = this.props

    const navList = isExact ? ['Data Validation', 'History Data Validation'] :
      ['Data Validation', 'History Data Validation', 'Data Validation List']

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList} />
        <div>
          {routes.map((r, i) =>
            <Route
              key={i}
              path={`${url}${r.path}`}
              exact={r.exact}
              render={props => getProtectedRoute(r, props)}
            />
          )}
        </div>
      </PageWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userLogin: state.userLogin,
    viewState: state.viewState
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(DataValidationRouter)
);